import { ScrollSmoother, ScrollTrigger } from '@/lib/gsap';

export const scrollToSlideIndex = (
	trigger: ScrollTrigger,
	index: number,
	slidesCount: number,
	behavior: ScrollBehavior = 'auto'
) => {
	const start = Number(trigger.start);
	const end = Number(trigger.end);
	const progress = index / Math.max(slidesCount - 1, 1);
	const rawTargetY = start + (end - start) * progress;
	const targetY = index === 0 ? Math.ceil(rawTargetY) : rawTargetY;

	const smoother = ScrollSmoother.get();

	if (smoother) smoother.scrollTo(targetY, !behavior || behavior === 'auto');
	else window.scrollTo({ top: targetY, behavior });
};
